'use strict';
const angular = require('angular');

export class signatureModalComponent {
  /*@ngInject*/
  constructor() {
    this.disabled = false;
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.instructions = this.config.instructions;
  };

  ok() {

    this.close({$value: this.signature.dataUrl});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduApp.signatureModal', [])
  .component('signatureModal', {
    template: require('./signature-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: signatureModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/signature-modal/signature-modal.component.js